<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a routerLink="/{{getUserCurrent().company.uniqid}}/announcementLog">Announcement Log</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            List Recipients
          </li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div class="row">
        <div class="pb-2 mb-3 border-bottom col-12">
          <h2>
            <b>Recipient list</b>
          </h2>
          <p>{{ announcement?.subject }} - {{ announcement?.sentAt | date:'MMM d, y H:mm' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>
            <p><b>This message has been sent to:</b></p>
            <p>{{ companies }}</p>
          </div>
          <p-panel [toggleable]="true">
            <ng-template pTemplate="header">
              <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
            </ng-template>
            <div class="row">
              <div class="col-3">
                <p-floatLabel>
                  <input [(ngModel)]="recipientFilterCriteria.company" (ngModelChange)="filter()" class="form-control" id="company"
                         pInputText type="text">
                  <label>Company</label>
                </p-floatLabel>
              </div>
              <div class="col-3">
                <p-floatLabel>
                  <input [(ngModel)]="recipientFilterCriteria.recipientName" (ngModelChange)="filter()" class="form-control" id="recipientName"
                         pInputText type="text">
                  <label>Recipient name</label>
                </p-floatLabel>
              </div>
              <div class="col-3">
                <p-floatLabel>
                  <input [(ngModel)]="recipientFilterCriteria.email" (ngModelChange)="filter()" class="form-control" id="email"
                         pInputText type="text">
                  <label>Email</label>
                </p-floatLabel>
              </div>
              <div class="col-3 p-float-label">
                <div class="row">
                  <div class="ml-auto mt-auto buttons-margin-left">
                    <div class="d-flex mt-2">
                      <div class="mr-2">
                        <button (click)="reset()" icon="fa fa-refresh pr-2" iconPos="left" label="Reset" pButton
                                type="button"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-panel>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <p-table [columns]="cols" [paginator]="true" [rows]="100"
                   [value]="filteredRecipientsList" class="text-table" totalRecords="size">
            <ng-template let-cols pTemplate="header">
              <tr>
                <th *ngFor="let col of cols" [style.width]="col.width">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template let-recipient pTemplate="body">
              <tr>
                <td>{{ recipient.company }}</td>
                <td>{{ recipient.recipientName }}</td>
                <td>{{ recipient.email }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              {{ size }} results
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="d-flex justify-content-end buttons-margin-left mt-3">
        <button class="btn btn-outline-primary" routerLink="/{{getUserCurrent().company.uniqid}}/announcementLog"
                type="button">
          <i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>
          Announcement Log
        </button>
      </div>
    </div>
  </div>
</div>
